import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { useContext, useEffect } from 'react';

import { getAccessTokenFromLS } from '@martech-solution/utils/utils';
import { getUserResourceFullAccess } from 'src/apis/master_data/userResource.api';
import { AppContext } from 'src/contexts/app.context';
import type { IResourceFullAccessDetail, IUserResourceFullAccess } from 'src/types/master_data/userResource.type';

// Hàm util để gộp quyền theo path
function normalizeResourcePermissions(details?: IResourceFullAccessDetail[]) {
  const _resourcePermissions: IResourceFullAccessDetail[] = [];

  details?.forEach(({ path, permissions, hrTicketCategoryCode, name }) => {
    if (!path) return;

    const pathRoots = path.split(',');
    pathRoots.forEach((pathString) => {
      const index = _resourcePermissions.findIndex((x) => x.path === pathString);

      if (index === -1) {
        _resourcePermissions.push({
          path: pathString,
          permissions,
          name,
          hrTicketCategoryCode
        });
      } else {
        _resourcePermissions[index] = {
          path: pathString,
          name,
          hrTicketCategoryCode,
          permissions: [..._resourcePermissions[index].permissions, ...permissions]
        };
      }
    });
  });

  return _resourcePermissions;
}

export function useUserResources() {
  const { setResources, setUserInfo, setResourcePermissionLoading } = useContext(AppContext);

  const token = getAccessTokenFromLS();

  const { isFetching } = useQuery({
    queryKey: ['userAccessResource', token],
    queryFn: async () => await getUserResourceFullAccess(),
    staleTime: 60 * 1000 * 10,
    enabled: !!token,
    onSuccess: (data: AxiosResponse<IUserResourceFullAccess>) => {
      // Set Resource
      const normalized = normalizeResourcePermissions(data.data?.details);
      setResources(normalized);

      // Set User Info
      if (data.data.employee) {
        setUserInfo(data.data.employee);
        localStorage.setItem('userInfo', JSON.stringify(data.data.employee));
      }
    }
  });

  useEffect(() => {
    setResourcePermissionLoading(isFetching);
  }, [isFetching, setResourcePermissionLoading]);
}
